import { render, staticRenderFns } from "./AcompanhamentoItem.vue?vue&type=template&id=3bed4131"
import script from "./AcompanhamentoItem.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports